import { withStyles } from '@material-ui/core/styles'
import Popup from 'Components/Popup'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'
import { createCampaignInternalCodes } from '../../../../gql/createCampaignInternalCodes'
import styles from '../styles'
import useGetInternalMultiplyCityBasicTrackingPopup from './InternalMultiplyBasic/useGetInternalMultiplyCityBasicTrackingPopup'
import useGetSingleCityAdvancedTrackingPopup from './InternalSingleBasic/useGetInternalSingleCityBasicTrackingPopup'

const InternalCodeUploadPopup = ({
  onClose,
  isOpen,
  mapInternalCodesTable,
  isCodesUploading,
  setIsCodesUploading,
  campaigns,
}) => {
  // eslint-disable-next-line no-unused-vars
  const [file, setFile] = useState(null)
  const [fileError, setFileError] = useState(null)
  const [warning, setWarning] = useState(null)
  const [codesTable, setCodesTable] = useState(null)
  const [trackingType, setTrackingType] = useState(null)
  const { campaignId } = useParams()
  const campaign = campaigns[campaignId]

  const citiesArray = campaign.cityPlans.nodes.map(node => ({
    name: node.city.name,
    id: node.city.id,
  }))

  const onCloseHandler = () => {
    setTrackingType(null)
    setFileError(null)
    setWarning(null)
    setCodesTable(null)
    onClose()
  }

  const onConfirm = async () => {
    setIsCodesUploading(true)
    try {
      const response = await createCampaignInternalCodes({
        campaignId: campaignId,
        internalCodes: codesTable,
      })
      const result = await response.json()
      const codes = result.data.createCampaignInternalCodes.internalCodes
      mapInternalCodesTable(codes)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error({ e })
    } finally {
      setFileError(null)
      setWarning(null)
      setFile(null)
      setIsCodesUploading(false)
      onClose()
    }
  }

  if (!isOpen) {
    return null
  }

  const payload = {
    onConfirm,
    onClose: onCloseHandler,
    isCanBeConfirmed: !fileError && !!codesTable,
    setCriticalError: setFileError,
    setFile,
    error: fileError,
    warning,
    setCodesTable,
    setWarning,
    citiesArray,
    isCodesUploading,
  }

  const {
    title: multiplyTitle,
    body: multiplyBody,
    footer: multiplyFooter,
  } = useGetInternalMultiplyCityBasicTrackingPopup(payload)

  const {
    title: singleTitle,
    body: singleBody,
    footer: singleFooter,
  } = useGetSingleCityAdvancedTrackingPopup(payload)

  let title
  let Body
  let Footer

  if (campaign.cityPlans.nodes.length > 1) {
    title = multiplyTitle
    Body = multiplyBody
    Footer = multiplyFooter
  } else {
    title = singleTitle
    Body = singleBody
    Footer = singleFooter
  }

  return (
    <Popup
      title={title}
      onCancel={onCloseHandler}
      body={Body}
      footer={Footer}
      showCross
      canBeClose={!isCodesUploading}
      showBack={trackingType ? true : false}
      backHandler={() => {
        setTrackingType(null)
      }}
    />
  )
}

const mapStateToProps = (state, props) => ({
  campaigns: state.campaigns.campaigns,
  state: state,
})

export default connect(mapStateToProps)(
  withStyles(styles)(InternalCodeUploadPopup),
)
